import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { OrderStore } from '../../../../stores/order.store';
import { V2BottomSheetRef } from '../../../../v2-components/helpers/v2-bottom-sheet-ref';
import { TableStore } from '../../../../stores/table.store';
import { TimeService } from '../../../../services/time.service';
import { OrderAheadStore } from '../../../../stores/order-ahead.store';

@Component({
  selector: 'time-slot-conflict-sheet',
  templateUrl: 'time-slot-conflict.sheet.html',
  styleUrls: ['time-slot-conflict.sheet.scss']
})
export class TimeSlotConflictSheet {
  constructor(
    public orderStore: OrderStore,
    public bottomSheetRef: V2BottomSheetRef<string>,
    public timeService: TimeService,
    private router: Router,
    private tableStore: TableStore,
    public orderAheadStore: OrderAheadStore
  ) {}

  readonly nonNullTimeSlotSuggestions$: Observable<
    string[]
  > = this.orderAheadStore.timeSlotConflictSuggestions$.pipe(
    map(
      (suggestions) =>
        suggestions.filter((s) => typeof s === 'string') as string[]
    )
  );

  readonly areThereAnyTimeSlotSuggestions$: Observable<boolean> = this.nonNullTimeSlotSuggestions$.pipe(
    map((suggestions) => suggestions.length > 0)
  );

  async sendUserToScanPage(): Promise<void> {
    this.bottomSheetRef.close();
    await this.router.navigate(
      ['/scan', this.tableStore.currentTable?.beaconId],
      {
        replaceUrl: true
      }
    );
  }

  readonly currentlySelectedDateTimeDisplayString$: Observable<string> = this.orderAheadStore.selectedTime$.pipe(
    map((selectedTime) =>
      this.timeService.getReadableDateTime(selectedTime, '')
    )
  );
}
